/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkflowTeam } from './workflowTeam';
import { SwimLane } from './swimLane';
import { WorkflowStep } from './workflowStep';
import { CompanyBaseData } from './companyBaseData';


export interface Workflow { 
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    _id: string;
    name: string;
    attachExistingAssets: boolean;
    description?: string;
    accessKeys?: Array<string>;
    workflowTypeId?: number;
    numberOfSwimlane?: number;
    workflowSwimlanes?: Array<SwimLane>;
    currentStepId?: number;
    lastStepId?: number;
    status?: string;
    agencies?: Array<CompanyBaseData>;
    allSteps?: Array<WorkflowStep>;
    bulkUploadTask?: boolean;
    automaticTransitionWF?: boolean;
    automaticSubTaskCreationFlag?: boolean;
    workflowTeams?: Array<WorkflowTeam>;
    workflowGraph?: object;
    workflowGraphPath?: Array<string>;
}

